import { GiftCarousel } from '@frontend/storefront/components/home/gift-carousel';
import {
  BookGrid,
  Faq,
  Features,
  Testimonials,
} from '@frontend/storefront/components/home/sections';
import { SplitPanel } from '@frontend/storefront/components/home/split-panel';
import Footer from '@frontend/storefront/components/layout/footer';

const description =
  "Create a custom book personalized to your kid's interests, and your values.";

export const metadata = {
  description,
  openGraph: {
    type: 'website',
  },
};

const mariaQuote = {
  text: 'My daughter used to ask for the tablet the minute we sat down at a restaurant, and now she asks for her nopad book.',
  author: 'Maria, mom of a 6-year-old',
};

const quotes = [
  mariaQuote,
  {
    text: 'Bedtime went from 20 minutes of negotiating to him reading quietly on his own until his eyes close.',
    author: 'Daniel, dad of a 5-year-old',
  },
];

const gifts = [
  'Kid',
  'Siblings',
  'Friends',
  'Mom',
  'Dad',
  'Grandparents',
  'Teacher',
].map((label) => ({
  label,
  src: `/home/gift-${label.toLowerCase()}.jpg`,
}));

const features = [
  {
    icon: '/home/icon-gift.svg',
    title: 'Personalized gift',
    text: 'A book where your kid is the hero, not a character they read about',
  },
  {
    icon: '/home/icon-reading.svg',
    title: 'Fall in love reading',
    text: "The book they'll ask for, because they're the hero",
  },
  {
    icon: '/home/icon-values.svg',
    title: 'Your values',
    text: "The lessons you care about, told as an adventure they'll remember.",
  },
];

const books = [
  'Our friendship',
  'Stop, picture, go',
  'Green flag',
  'Stand tall',
].map((title, i) => ({ title, src: `/home/book-${i + 1}.webp` }));

const questions = [
  {
    question: 'Who is nopad for?',
    answer:
      'Kids roughly 3 to 9 years old. Younger kids love being read to as the hero; older kids read it on their own.',
  },
  {
    question: 'What do I need to tell you about my kid?',
    answer:
      "Their name, a photo if you'd like them illustrated, a few things they love, and the value you want the story to carry. It takes about five minutes.",
  },
  {
    question: 'How long until the book arrives?',
    answer:
      'Each book is written and printed just for your kid, so allow 7 to 10 days for printing plus shipping time to your address.',
  },
  {
    question: "Can I see the book before it's printed?",
    answer:
      'Yes. You get a preview of the full story and can ask for changes before anything goes to print.',
  },
  {
    question: "Can I order it as a gift for someone else's kid?",
    answer:
      'Of course. Grandparents, aunts, uncles, teachers and friends order nopad books all the time. You can ship straight to the family.',
  },
  {
    question: 'What if something is wrong with my book?',
    answer:
      "If it arrives damaged or with a printing error, write to us and we'll reprint it at no cost.",
  },
];

export default function HomePage() {
  return (
    <>
      <SplitPanel
        heading="Make a book for your kid where they are the hero"
        headingLevel="h1"
        text={description}
        image={{
          src: '/home/hero.jpg',
          alt: 'A boy reading his personalized nopad book in bed',
          width: 1300,
          height: 1196,
        }}
        priority
      />
      <Testimonials quotes={quotes} />
      <GiftCarousel
        heading="Gifts for all your favorite people"
        gifts={gifts}
      />
      <Features
        heading="Written for your kid and their world"
        features={features}
      />
      <SplitPanel
        heading="Raise a small booklover"
        quote={mariaQuote}
        image={{
          src: '/home/booklover.jpg',
          alt: 'A toddler reaching for a book on a bookshelf',
          width: 1127,
          height: 1400,
        }}
        mediaPosition="left"
      />
      <BookGrid heading="Recently created" books={books} />
      <Faq heading="Questions parents ask" questions={questions} />
      <Footer />
    </>
  );
}
